if (!customElements.get("product-form")) {
  class a extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      var e;
      this.selectors = {
        form: this.querySelector("form"),
        product: this.querySelector('[name="product-id"]'),
        handle: this.querySelector('[name="product-handle"]'),
        variant: this.querySelector('[name="id"]'),
        quantity: this.querySelector('[name="quantity"]'),
        options: this.querySelectorAll("product-option"),
        options_input: this.querySelectorAll('product-option input[type="radio"]'),
        properties: this.querySelectorAll('[name*="properties["]'),
        button: this.querySelector('button[type="submit"]'),
        additional_options: this.querySelectorAll(".product-option--additional"),
        dropdown: this.querySelectorAll(".product-option__dropdown"),
      };
      
      if (!this.selectors.variant) return; // safety check
      
      this.variants = Array.from(this.selectors.variant.querySelectorAll("option")).map((e) => ({
        id: e.value,
        title: e.innerText,
        values: e.innerText.split(" / "),
        available: !e.getAttribute("disabled"),
      }));
      
      localStorage.getItem("pdp_selected_values")
        ? (this.selected_values = JSON.parse(localStorage.getItem("pdp_selected_values")))
        : (this.selected_values = this.getSelectedValues());
      
      window.selected_values = this.selected_values;
      this.listen();
      
      if (localStorage.getItem("pdp_selected_values")) {
        this.selectors.options_input.forEach((e) => {
          if (this.selected_values.indexOf(e.value) !== -1) {
            e.checked = true;
            e.dispatchEvent(new Event("change"));
          }
        });
        
        e = this.findVariant(this.selected_values);
        if (e) {
          this.updateSubmitButton(e);
          this.selectors.variant.value = e.id;
          this.selectors.variant.dispatchEvent(new Event("change"));
          setTimeout(() => {
            window.dispatchEvent(
              new CustomEvent("variantChange", {
                detail: {
                  product: this.selectors.handle ? this.selectors.handle.value : "",
                  variant: this.selectors.variant.value,
                  available: e.available,
                },
              }),
            );
          }, 0);
        }
        localStorage.removeItem("pdp_selected_values");
      }
      
      if (this.selectors.options.length > 0) {
        this.disableValues(this.selectors.options[0]);
      }
      if (this.selectors.additional_options.length > 0) {
        this.disableAdditionalValues(this.selectors.additional_options[0]);
      }
    }
    listen() {
      (this.selectors.options.forEach((t, e) => {
        t.addEventListener("valueChange", () => {
          this.selected_values = this.getSelectedValues();
          var e = this.findVariant(this.selected_values);
          if (e) {
            this.updateSubmitButton(e);
            this.selectors.variant.value = e.id;
            this.selectors.variant.dispatchEvent(new CustomEvent("change"));
            this.disableValues(t);
            window.dispatchEvent(
              new CustomEvent("variantChange", {
                detail: {
                  product: this.selectors.handle ? this.selectors.handle.value : "",
                  variant: this.selectors.variant.value,
                  available: e.available,
                },
              }),
            );
          }
          window.selected_values = this.selected_values;
        });
      }),
        this.selectors.additional_options.forEach((e) => {
          e.addEventListener("click", () => {
            localStorage.setItem(
              "pdp_selected_values",
              JSON.stringify(this.selected_values),
            );
          });
        }),
        this.selectors.form.addEventListener(
          "submit",
          (e) => (e.preventDefault(), this.submit(), !1),
        ),
        this.selectors.variant.addEventListener("change", (e) => {
          var t =
            window.location.origin +
            window.location.pathname +
            ("?variant=" + this.selectors.variant.value);
          (history.pushState({ variant: e.target.value }, "", t),
            this.updateVariant());
        }),
        this.selectors.dropdown.forEach((t) => {
          let a = t.querySelector(".product-option__dropdown-btn"),
            s = a.querySelector("[data-text-active]");
          (a
            .closest(".product-option__dropdown")
            .addEventListener("click", (e) => {
              (e.stopPropagation(),
                localStorage.setItem(
                  "pdp_selected_values",
                  JSON.stringify(this.selected_values),
                ));
            }),
            a.addEventListener("click", (e) => {
              (e.stopPropagation(),
                "false" === a.getAttribute("aria-expanded")
                  ? (a.setAttribute("aria-expanded", "true"),
                    (s.innerHTML = s.dataset.textActive))
                  : (a.setAttribute("aria-expanded", "false"),
                    (s.innerHTML = s.dataset.textDefault)),
                setTimeout(() => window.dispatchEvent(new Event("resize"))));
            }),
            t.querySelectorAll('input[type="radio"]').forEach((e) => {
              e.addEventListener("change", () => {
                (t
                  .querySelectorAll("li")
                  .forEach((e) =>
                    e.classList.remove("product-option__value--active"),
                  ),
                  e
                    .closest("li")
                    .classList.add("product-option__value--active"),
                  a.setAttribute("aria-expanded", "false"),
                  (s.innerHTML = s.dataset.textDefault));
              });
            }));
        }),
        (this._bodyClickHandler = () => {
          this.closeDropdowns();
        }),
        document.body.addEventListener("click", this._bodyClickHandler),
        (this._popstateHandler = (e) => {
          e.state &&
            ((this.selectors.variant.value = e.state.variant),
            this.updateVariant());
        }),
        window.addEventListener("popstate", this._popstateHandler));
    }
    getSelectedValues() {
      return Array.from(this.selectors.options).map((e) => {
        var t = e.querySelector('input[type="radio"]:checked');
        return t ? t.value : e.dataset.value || "";
      });
    }
    findVariant(a) {
      let t = !1;
      if (
        !(this.variants.length < 0 || a.length < this.selectors.options.length)
      )
        return (
          this.variants.forEach((e) => {
            e.values.every((e, t) => e === a[t]) && (t = e);
          }),
          t
        );
    }
    updateSubmitButton(e) {
      if (this.selectors.button) {
        this.selectors.button.disabled = !e.available;
      }
    }
    setSubmitButtonLoading(e) {
      if (!this.selectors.button) return;
      e
        ? this.selectors.button.classList.add("loading")
        : this.selectors.button.classList.remove("loading");
    }
    updateVariant() {
      document.querySelectorAll("[data-variant-detail]").forEach((e) => {
        -1 !=
        e.dataset.variantDetail.split(",").indexOf(this.selectors.variant.value)
          ? e.classList.add("selected")
          : e.classList.remove("selected");
      });
    }
    disableValues(t) {
      this.selectors.options.forEach((e, a) => {
        e.dataset.handle !== t.dataset.value &&
          e.querySelectorAll('input[type="radio"]').forEach((e) => {
            var t = [...this.selected_values],
              t = ((t[a] = e.value), this.findVariant(t));
            t && (e.disabled = !t.available);
          });
      });
    }
    disableAdditionalValues(e) {
      let i = [];
      (this.selectors.additional_options.forEach((e) => {
        e = e.querySelector(".product-option__value--active");
        e && i.push(e.dataset.value);
      }),
        this.selectors.additional_options.forEach((e) => {
          let s = e.querySelector(".product-option__value--active");
          s &&
            e
              .querySelectorAll(
                "[data-value][data-values]:not(.product-option__value--active)",
              )
              .forEach((e) => {
                let t = e.dataset.values.split("/"),
                  a = (-1 != t.indexOf(s.dataset.value) && e.remove(), !0);
                (i.forEach((e) => {
                  e != s.dataset.value && -1 == t.indexOf(e) && (a = !1);
                }),
                  a || e.remove());
              });
        }));
    }
    submit() {
      if (this.selectors.button && this.selectors.variant.value) {
        var e = { items: [] };
        let a = {};
        (this.setSubmitButtonLoading(true),
          this.selectors.properties.forEach((e) => {
            var t;
            e.value &&
              ((t = e.name.replace("properties[", "").replace("]", "")),
              (a[t] = e.value));
          }),
          e.items.push({
            id: this.selectors.variant.value,
            quantity: this.selectors.quantity.value,
            properties: a,
          }),
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(e),
          })
            .then((e) => e.json())
            .then((e) => {
              (e.items &&
                (window.dispatchEvent(new CustomEvent("cartAdded")),
                window.dispatchEvent(new CustomEvent("cartCounterUpdate"))),
                setTimeout(() => {
                  this.setSubmitButtonLoading(false);
                }, 1e3));
            })
            .catch((e) => {
              this.setSubmitButtonLoading(false);
              console.log(e);
            }));
      }
    }
    closeDropdowns() {
      (this.selectors.dropdown.forEach((e) => {
        var e = e.querySelector(".product-option__dropdown-btn"),
          t = e.querySelector("[data-text-active]");
        (e.setAttribute("aria-expanded", "false"),
          (t.innerHTML = t.dataset.textDefault));
      }),
        setTimeout(() => window.dispatchEvent(new Event("resize"))));
    }
    disconnectedCallback() {
      if (this._bodyClickHandler) {
        document.body.removeEventListener("click", this._bodyClickHandler);
      }
      if (this._popstateHandler) {
        window.removeEventListener("popstate", this._popstateHandler);
      }
    }
  }
  customElements.define("product-form", a);
}
